module.exports = __webpack_public_path__ + "static/media/A18040103_10003_5.c0b13e3e.jpg";